import styled from "styled-components";

import Spacings from "../Spacings";

const FormField = styled(Spacings.Stack)``;

export default FormField;
